import { Link } from "react-router-dom"
import styles from "./quick-pitch.module.css"

export function QuickPitch() {
  return (
    <section className={styles.section}>
      <div className={styles.pitchContainer}>
        {/* Background accent */}
        <div className={styles.pitchBackground}></div>

        {/* Content */}
        <div className={styles.pitchContent}>
          {/* Sparkle icon */}
          <div className={styles.pitchIcon}>💫</div>

          {/* Heading */}
          <h2 className={styles.pitchTitle}>Become a trusted Pixel Moon Store Reseller!</h2>

          {/* Main message */}
          <p className={styles.pitchMessage}>
            <span className={styles.pitchHighlight}>Join the Pixel Moon Store Reseller Galaxy</span> — sell, save, and
            rise. Unlock VIP status while maximizing profits, enjoy exclusive perks, and become part of a trusted cosmic
            community. Your journey from{" "}
            <span className={styles.pitchHighlight}>Lunar Initiate to Celestial Overload</span> starts here!
          </p>

          {/* CTA */}
          <Link to={"/retail"}>
            <button className={styles.pitchButton}>Start Your Journey</button>
          </Link>
        </div>
      </div>
    </section>
  )
}
